export function formatDate (date, fmt) {
  'use strict'

  fmt = fmt || 'yyyy-MM-dd'

  if (date && date.toString().length === 10) {
    date = (+date) * 1000
  }

  if (!date) {
    return ''
  }

  if (Object.prototype.toString.call(date) !== '[object Date]') {
    date = new Date(+date)
  }

  const o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    S: date.getMilliseconds() // 毫秒
  }

  if (/(y+)/.test(fmt)) { fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length)) }
  for (const k in o) { if (new RegExp('(' + k + ')').test(fmt)) { fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length))) } }

  return fmt
}

export function getSystemInfo () {
  const ua = navigator.userAgent.toLowerCase()

  if (/android/.test(ua)) {
    return 'android'
  } else if (/iphone|ipad|ipod/.test(ua)) {
    return 'ios'
  }
}

export function throttle (func, wait, options) {
  let timeout, context, args
  let previous = 0

  if (!options) { options = {} }

  const later = function () {
    previous = options.leading === false ? 0 : new Date().getTime()
    timeout = null
    func.apply(context, args)
    if (!timeout) { context = args = null }
  }

  const throttled = function () {
    const now = new Date().getTime()

    if (!previous && options.leading === false) { previous = now }
    const remaining = wait - (now - previous)

    context = this
    args = arguments
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout)
        timeout = null
      }
      previous = now
      func.apply(context, args)
      if (!timeout) { context = args = null }
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining)
    }
  }

  throttled.cancel = function () {
    clearTimeout(timeout)
    previous = 0
    timeout = null
  }
  return throttled
}

export function request (name, link) {
  const url = decodeURI(link || location.href)
  const paraObj = {}
  const paraObjList = url.split('?').slice(1)
  let paraString = []
  let returnValue = ''

  const requestHandler = function (paraList) {
    const result = []

    for (let index = 0; index < paraList.length; index++) {
      paraList[index] = paraList[index].split('#')[0]
      result.push(paraList[index])
    }
    return result.join('&').split('&')
  }

  paraString = requestHandler(paraObjList)

  // 将所有请求参数放入paraObj
  let temp = ''

  for (let i = 0, length = paraString.length; i < length; i++) {
    temp = paraString[i]
    paraObj[temp.substring(0, temp.indexOf('=')).toLowerCase()] = temp.substring(temp.indexOf('=') + 1, temp.length)
  }

  returnValue = paraObj[name.toLowerCase()] || ''

  return returnValue
}

export function queryObj () {
  const str = location.search

  if (str) {
    const url = str.substr(1)
    const arr = url.split('&')
    const len = arr.length
    const request = {}

    for (let i = 0; i < len; i++) {
      request[arr[i].split('=')[0]] = arr[i].split('=')[1]
    }
    return request
  } else {
    return {}
  }
}

export function setcookie (key, value, expireHours) {
  let cookieString = key + '=' + escape(value) + '; path=/'

  // 判断是否设置过期时间

  if (expireHours > 0) {
    const date = new Date()

    date.setTime(date.getTime() + expireHours * 3600 * 1000)
    cookieString = cookieString + '; expire=' + date.toGMTString()
  }
  document.cookie = cookieString
}

export function objectMerge (target, source) {
  if (typeof target !== 'object') {
    target = {}
  }
  if (Array.isArray(source)) {
    return source.slice()
  }
  for (const property in source) {
    // eslint-disable-next-line
    if (source.hasOwnProperty(property)) {
      const sourceProperty = source[property]

      if (typeof sourceProperty === 'object') {
        target[property] = objectMerge(target[property], sourceProperty)
        continue
      }
      target[property] = sourceProperty
    }
  }
  return target
}

export function setParam (name, val, url) {
  if (typeof name !== 'string') { return false }
  if (!url) { url = window.location.href }
  // eslint-disable-next-line
  const _name = name.replace(/[\[\]]/g, '\\$&')
  const value = name + '=' + encodeURIComponent(val)
  const regex = new RegExp(_name + '=[^&]*')
  const urlArr = url.split('#')
  let result = ''

  if (regex.exec(url)) { result = url.replace(regex, value) } else { result = urlArr[0] + '&' + value + (urlArr[1] || '') }
  return result
}

export function setParams (obj, url) {
  let result = url || window.location.href

  if (Object.prototype.toString.call(obj) !== '[object Object]') { return false }
  for (const name in obj) {
    result = setParam(name, obj[name], result)
  }
  return result
}

export function isEmptyObject (obj) {
  return Object.keys(obj).length === 0
}

export function loadJs (url) {
  return new Promise((resolve, reject) => {
    const head = document.querySelector('head')
    const script = document.createElement('script')
    let loaded = false

    script.setAttribute('src', url)
    script.onload = script.onreadystatechange = function () {
      if (!loaded && (!this.readyState || this.readyState == 'loaded' || this.readyState == 'complete')) {
        loaded = true
        resolve('success')
        script.onload = script.onreadystatechange = null
        head.removeChild(script)
      } else {
        reject(new Error('not loaded!'))
      }
    }

    head.appendChild(script)
  })
}

export function captureException (error) {
  return window.$Raven.captureException(error)
}

export function isDev () {
  return process.env.BUILD_ENV == 'development' || process.env.BUILD_ENV == 'test'
}
export function isUat () {
  return process.env.BUILD_ENV == 'uat'
}

export function isPro () {
  return process.env.BUILD_ENV == 'production'
}
